import * as React from "react"
import PropTypes from "prop-types"

import HeaderUpdate from "./header-update"
import FooterNewUpdate from "./footer-new-update"

const Layout = ({ children }) => (
  <>
    <HeaderUpdate />
    <div>
      <main>
        {children}
      </main>
    </div>
    <FooterNewUpdate />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout